import { cn } from '@/utils/cn';
import type { IconProps, IconSize } from './Icon.types';
import styles from './Icon.module.scss';

const ICON_SIZES: Record<IconSize, number> = {
  xs: 12,
  sm: 16,
  md: 20,
  lg: 24,
  xl: 32,
};

export function Icon({
  icon: LucideIcon,
  size = 'md',
  className,
  'aria-label': ariaLabel,
  ...props
}: IconProps) {
  const iconClasses = cn(styles.icon, styles[`icon--${size}`], className);
  const iconSize = ICON_SIZES[size];

  // Lucide SVGs have no implicit ARIA role; label only when the icon carries meaning without surrounding text.
  const accessibilityProps = ariaLabel
    ? { role: 'img', 'aria-label': ariaLabel }
    : { 'aria-hidden': true };

  return (
    <LucideIcon
      className={iconClasses}
      size={iconSize}
      strokeWidth={2}
      {...accessibilityProps}
      {...props}
    />
  );
}

export default Icon;
